// import 'react-international-phone/style.css';

import { FormControl, FormErrorMessage, FormLabel, Input, InputGroup, InputRightElement } from '@chakra-ui/react';
import { IconComp } from 'components/base/IconComp';
import { Field } from 'formik';
import { InputFormField } from 'models';
import React, { FunctionComponent } from 'react';

import { getLabelName, validateInputField } from '../../utils/form/validation';
import { CurrencySelectExample } from './CurrencyField';
interface InputFieldProps {
  model: InputFormField;
}

export const InputField: FunctionComponent<InputFieldProps> = ({ model }) => {
  //  const [phone, setPhone] = React.useState('')
  //  const [currency, setCurrency] = React.useState('USD');

  //  const handleCurrencyChange = (event) => {
  //    const { value } = event.target;
  //    setCurrency(value);
  //  };
  return (
    <Field name={model.elements.name.value} validate={validateInputField(model)}>
      {({ field, form }) => (
        <FormControl isInvalid={form.errors[model.elements.name.value] && form.touched[model.elements.name.value]}>
          {model.elements.label.value !== '' && <FormLabel>{getLabelName(model)}</FormLabel>}
          <InputGroup>
            {model.elements.label.value == 'Amount applied for' && <CurrencySelectExample />}
            <Input
              //  type={model.elements.type.value[0].codename === 'number' ? 'text' : model.elements.type.value[0].codename}
              type={model.elements.type.value[0].codename}
              //  pattern={ model.elements.type.value[0].codename === 'alphanumeric' && "[a-zA-Z0-9 ]+"}
              {...field}
              placeholder={model.elements.placeholder.value}
              textStyle='mobile.body.s'
              bg={'white'}
              color={'mountain.60'}
            />{' '}
            {form.errors[model.elements.name.value] && form.touched[model.elements.name.value] && (
              <InputRightElement>
                <IconComp iconName={'alert'} />
              </InputRightElement>
            )}
          </InputGroup>
          <FormErrorMessage>{form.errors[model.elements.name.value]}</FormErrorMessage>
        </FormControl>
      )}
    </Field>
  );
};
